export default __webpack_public_path__ + "static/media/curso_intermedio_cover.d48c1c6a.png";